import { ToastContext } from '@/entities/toast/lib/context'
import { ToastMessage, ToastType } from '@/entities/toast/model/types'
import {
  Toast,
  ToastClose,
  ToastDescription,
  ToastProvider,
  ToastTitle,
  ToastViewport,
} from '@/features/toast/ui/Toast'
import { ReactNode, useState } from 'react'
import { v4 as uuidv4 } from 'uuid'

export function ToastContextProvider({ children }: { children: ReactNode }) {
  const [toasts, setToasts] = useState<ToastMessage[]>([])

  const addToast = (title: string, description?: string, variant: ToastType = 'default') => {
    const id = uuidv4()
    setToasts((prev) => [...prev, { id, title, description, variant }])

    setTimeout(() => removeToast(id), 5000)
  }

  const removeToast = (id: string) => {
    setToasts((prev) => prev.filter((toast) => toast.id !== id))
  }

  return (
    <ToastContext.Provider value={{ addToast }}>
      <ToastProvider>
        {children}
        <div className="right-4 bottom-4 fixed flex flex-col gap-2">
          {toasts.map(({ id, title, description, variant }) => (
            <Toast key={id} variant={variant}>
              <div className="flex flex-col gap-1">
                {title && <ToastTitle>{title}</ToastTitle>}
                {description && <ToastDescription>{description}</ToastDescription>}
              </div>
              <ToastClose />
            </Toast>
          ))}
        </div>
        <ToastViewport />
      </ToastProvider>
    </ToastContext.Provider>
  )
}
